// import React from "react";
// import { IoSearchOutline,  IoNotificationsOutline } from "react-icons/io5";
// import "./Header.css";

// const Header = () => {
//   return (

//     <div className="header">
//       <div className="header-top">
        
//          <div className="search-bar">
//           <IoSearchOutline className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search for anything"
//             className="search-input"
//           />
//         </div> 

//          <div className="notification">
//            <IoNotificationsOutline className="notification-icon" />
//            <span className="notification-dot"></span>
//          </div>

//       </div>

//          <div className="header-bottom">
//            <h1 className="inner"> Dashboard Overview</h1>
//          </div>
        
//       </div>
//   );
// };

// export default Header;


import React, { useState } from "react";
import { MdSearch, MdNotifications, MdClose } from "react-icons/md";
import "./Header.css";

const Header = () => {
  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className="notification-header">
      {/* HEADER ROW */}
      <div className="header-row">

        {/* LEFT: Title */}
        <div className="header-title">
          <h2>Dashboard Overview</h2>
        </div>

        {/* RIGHT: Search + Notifications */}
        <div className="header-actions">

          {/* DESKTOP SEARCH */}
          <div className="search-desktop">
            <MdSearch />
            <input
              type="text"
              placeholder="Search for anything"
            />
          </div>

          {/* MOBILE SEARCH ICON */}
          <button
            className="search-mobile-btn"
            onClick={() => setShowSearch(true)}
          >
            <MdSearch />
          </button>

          {/* NOTIFICATION */}
          <div className="notification-icon">
            <MdNotifications />
            {/* <span className="notification-dot"></span> */}
          </div>
        </div>
      </div>

      {/* MOBILE SEARCH OVERLAY */}
      {showSearch && (
        <div className="mobile-search">
          <div className="mobile-search-box">
            <MdSearch />
            <input
              autoFocus
              type="text"
              placeholder="Search for anything"
            />
            <button onClick={() => setShowSearch(false)}>
              <MdClose />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;




